<script>
export default {
    name: 'SharedCarouselSlide',
}
</script>

<template>
    <div class="sharedCarouselSlide swiper-slide">
        <slot />
    </div>
</template>
